import BaseResource from './BaseResource';

export default class ReconciliationResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  update(data) {
    return super
      .patch(data, { url: `${this.url}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
